/**
 * 受講生の声の節の「投稿の壁」(VoiceWall.tsx) に並べる、受講生の X の投稿。
 * note の学習記録 (voice-notes.ts の VOICE_NOTES) と同じ壁に混ぜて、2 段で横に流す。
 *
 * 2026-10-21 に代表が、受講生が公開している X と note の投稿は、本人に 1 件ずつ聞かなくても HP に載せてよいと決めた。
 * 2026-10-22 に、受講生 3 人 (ぽてと、YuRicode、Koba) の本人の言葉が入った投稿 14 件を足した。取得と選別は PR の表と
 * notes-sandbox/ops/scratch/2026-10-22/voice-x/ に残してある (定型だけの投稿、note の題だけの投稿は載せていない)。
 * 外すときは 1 件消す。X も note も 0 件に戻れば壁ごと消える (VoiceWall が長さ 0 を見て何も描かない)。
 *
 * 足し方
 *  1. 投稿の書き手が受講生だと確かめる (本人の記事や投稿に受講中と書いてある、本人に聞いて URL をもらう、など)
 *  2. 下の VOICE_POSTS に 1 件足す。url は投稿の URL そのまま (https://x.com/<ハンドル>/status/<番号>)
 *  3. 本文と表示名は、https://publish.twitter.com/oembed?url=<投稿の URL>&omit_script=1 が返すものを原文のまま写す。
 *     切るのは行の終わりだけ。末尾の短縮 URL (t.co) とハッシュタグだけの行は、本人の言葉ではないので落とす
 *     (言い回しも改行も直さない。末尾が「…」で切れた長い投稿は、x.com で全文を開いて写す)
 *  4. name は X に出ている表示名そのまま、handle は @ を除いた英数字。本名と顔写真は足さない
 *  5. avatar は X のアイコン (https://pbs.twimg.com/profile_images/...)。末尾の _normal を _400x400 に替える。
 *     CSP の img-src に許可済み。顔が写っているアイコンは省く (省くと名前の頭の 1 字が出る)
 *  6. date は投稿の日付。YYYY-MM-DD
 *  7. 外すときは、その 1 件を消す。X も note も 0 件に戻れば壁ごと消える
 *
 * 並べ方は配列の順。同じ書き手が (note の書き手も含めて) 同じ段で隣り合わないように並べてある。壁は X と note を 1 件ずつ交互に混ぜ、0,1,1,0 の順で上と下の段へ配る。足すときは段に配ったあとも崩れないか確かめる。
 */
export type VoicePost = {
  /** 投稿の URL */
  url: string;
  /** X の表示名 */
  name: string;
  /** @ を除いたハンドル */
  handle: string;
  /** 本文の原文。改行もそのまま */
  text: string;
  /** 投稿の日付。YYYY-MM-DD */
  date: string;
  /** アイコンの URL。pbs.twimg.com の _400x400 */
  avatar?: string;
};

export const VOICE_POSTS: VoicePost[] = [
  {
    url: "https://x.com/poteto_code/status/2112774727974727973",
    name: "ぽてと",
    handle: "poteto_code",
    text: "学習パス 52 項目を済ませました\n\nコンピュータサイエンス（設計）\n\nこの辺はあとでつなげるために今はさらっと！！！！と心に決めおけ！！！",
    date: "2026-10-21",
    avatar: "https://pbs.twimg.com/profile_images/2092437781725446144/iSz3A4uy_400x400.jpg",
  },
  {
    url: "https://x.com/YuRicode73/status/2110018380120134057",
    name: "YuRicode",
    handle: "YuRicode73",
    text: "たくさん勉強して早くエンジニアになりたーいと思ってても時間は有限なので(逆立ちして地球一周したとしても1日24時間なのは不変なので)、綺麗事じゃなく、毎日コツコツ継続あるのみ！！！\n学習時間は見つけて作れるもの！",
    date: "2026-10-13",
    avatar: "https://pbs.twimg.com/profile_images/2098003112141479936/u-wD1poG_400x400.jpg",
  },
  {
    url: "https://x.com/poteto_code/status/2110960637593686061",
    name: "ぽてと",
    handle: "poteto_code",
    text: "レッスンをクリアしました！ +20XP\n仕様に苦しんだがそれに合わせて対処するのも役立ちそう",
    date: "2026-10-16",
    avatar: "https://pbs.twimg.com/profile_images/2092437781725446144/iSz3A4uy_400x400.jpg",
  },
  {
    url: "https://x.com/poteto_code/status/2110560512790696084",
    name: "ぽてと",
    handle: "poteto_code",
    text: "学習パス 48本目クリア！！\n\n宿題 ファイルパーミッションとユーザー管理\njs Linuxってありがたいがやれること限られてる…",
    date: "2026-10-15",
    avatar: "https://pbs.twimg.com/profile_images/2092437781725446144/iSz3A4uy_400x400.jpg",
  },
  {
    url: "https://x.com/Kobaeri_eng/status/2108915502844465586",
    name: "Koba",
    handle: "Kobaeri_eng",
    text: "学習パス 79本目クリア！！\n\n宿題 INSERT/UPDATE/DELETEを使ったSQL操作\n\nINSERTを2回実行して商品が重複してしまう事もあったりと焦る場面もありましたが、\n\n主キーやSELECTが、自分の手元で動くと理解の深さが違いますね",
    date: "2026-10-10",
    avatar: "https://pbs.twimg.com/profile_images/2061647841915998209/IWEbMOfZ_400x400.jpg",
  },
  {
    url: "https://x.com/poteto_code/status/2108458995031945426",
    name: "ぽてと",
    handle: "poteto_code",
    text: "学習パス 48本目クリア！！\n\nLinux入門 コマンド操作のきほん\nルートディレクトリとただのスラッシュでつむとこだった…",
    date: "2026-10-09",
    avatar: "https://pbs.twimg.com/profile_images/2092437781725446144/iSz3A4uy_400x400.jpg",
  },
  {
    url: "https://x.com/YuRicode73/status/2104226787643605377",
    name: "YuRicode",
    handle: "YuRicode73",
    text: "note更新しました🌼\n月一の学習発表会に参加したのでそちらの報告記録です\n\n自分が得た知識を整理できるだけでなく、他の発表者の方々のお話を聞き良い刺激を受けました💐",
    date: "2026-09-28",
    avatar: "https://pbs.twimg.com/profile_images/2098003112141479936/u-wD1poG_400x400.jpg",
  },
  {
    url: "https://x.com/poteto_code/status/2102979877846839639",
    name: "ぽてと",
    handle: "poteto_code",
    text: "学習パス 46本目クリア！！\n\n宿題 今月学んだことをnoteにアウトプット\n\nnoteをはじめて公開するだけで時間かかりすぎなんよ…",
    date: "2026-09-24",
    avatar: "https://pbs.twimg.com/profile_images/2092437781725446144/iSz3A4uy_400x400.jpg",
  },
  {
    url: "https://x.com/YuRicode73/status/2102665580541268021",
    name: "YuRicode",
    handle: "YuRicode73",
    text: "学習開始後3週間が経過したところです！\n引越しなどでバタついた影響もあり進みはゆっくりでもコツコツ継続するのは大事ですね\n---------\n学習パス 53本目クリア！！\nコンピュータサイエンス基礎",
    date: "2026-09-23",
    avatar: "https://pbs.twimg.com/profile_images/2098003112141479936/u-wD1poG_400x400.jpg",
  },
  {
    url: "https://x.com/poteto_code/status/2101179825960693898",
    name: "ぽてと",
    handle: "poteto_code",
    text: "学習パス 45本目クリア！！\n\n宿題 ログインの仕組みを図に書き起こしてみよう\n図が一辺倒になるからいろんな人の見て引き出し増やさないと汗",
    date: "2026-09-19",
    avatar: "https://pbs.twimg.com/profile_images/2092437781725446144/iSz3A4uy_400x400.jpg",
  },
  {
    url: "https://x.com/poteto_code/status/2100779459230208058",
    name: "ぽてと",
    handle: "poteto_code",
    text: "学習パス 43本目クリア！！\n\n宿題 Webの流れを図にして講師に提出しよう\n絵を描くツールに触れてこなかったので大苦戦",
    date: "2026-09-18",
    avatar: "https://pbs.twimg.com/profile_images/2092437781725446144/iSz3A4uy_400x400.jpg",
  },
  {
    url: "https://x.com/YuRicode73/status/2098775855191450065",
    name: "YuRicode",
    handle: "YuRicode73",
    text: "学習記録のためnoteはじめたよーん\n\nはじめに＆ゆめさく学習記録_Level.1｜YuRicode",
    date: "2026-09-12",
    avatar: "https://pbs.twimg.com/profile_images/2098003112141479936/u-wD1poG_400x400.jpg",
  },
  {
    url: "https://x.com/YuRicode73/status/2097989221890015258",
    name: "YuRicode",
    handle: "YuRicode73",
    text: "本日ももくもく👩‍💻\nRAG(Retrieval-Augmented Generation：自分で持っている、質問に関連する資料を渡してそこから答えてもらう)の仕組みについて学習📚",
    date: "2026-09-10",
    avatar: "https://pbs.twimg.com/profile_images/2098003112141479936/u-wD1poG_400x400.jpg",
  },
  {
    url: "https://x.com/YuRicode73/status/2096542210141700413",
    name: "YuRicode",
    handle: "YuRicode73",
    text: "生成AIに対して。\n人が今までやってきた仕事を奪ってくるっていう恐怖の方が便利さへの理解よりも勝ってたけど、学習を通して人間の能力を最大化させてくれる、より価値を出すところに時間を使わせてくれるようになるっていう捉え方ができるようになってる気がする💐🫶🏻",
    date: "2026-09-06",
    avatar: "https://pbs.twimg.com/profile_images/2098003112141479936/u-wD1poG_400x400.jpg",
  },
];
